import React, { useEffect, useState } from 'react';
import { HiUserGroup, HiUser, HiUserRemove } from 'react-icons/hi';

const UserWidgets = ({ counts }) => {
  const cards = [
    {
      label: 'Total Users',
      endNumber: counts?.totalUsers || 0,
      icon: <HiUserGroup className="w-8 h-8 text-[#c51369]" />,
    },
    {
      label: 'Active Users',
      endNumber: counts?.activeUsers || 0,
      icon: <HiUser className="w-8 h-8 text-[#c51369]" />,
    },
    {
      label: 'Inactive Users',
      endNumber: counts?.blockedUsers || 0,
      icon: <HiUserRemove className="w-8 h-8 text-[#c51369]" />,
    },
  ];

  return (
    <div className="mx-auto pt-3">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((card, index) => (
          <Card
            key={index}
            endNumber={card.endNumber}
            label={card.label}
            icon={card.icon}
          />
        ))}
      </div>
    </div>
  );
};

const Card = ({ endNumber, label, icon }) => {
  const [number, setNumber] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const incrementTime = 10;
    const step = endNumber / (duration / incrementTime);

    const timer = setInterval(() => {
      start += step;
      if (start >= endNumber) {
        start = endNumber;
        clearInterval(timer);
      }
      setNumber(Math.ceil(start));
    }, incrementTime);

    return () => clearInterval(timer);
  }, [endNumber]);

  return (
    <div className="flex flex-col justify-between items-center bg-white p-6 rounded-2xl shadow-sm text-navy-700 relative">
      <div className="absolute top-0 left-0 right-0 mt-2 flex justify-center">
        <div className="relative w-24 h-24">
          <svg className="absolute top-0 left-0 w-full h-full" viewBox="0 0 36 36">
            <path
              className="circle-bg"
              d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="#e6e6e6"
              strokeWidth="2"
            />
            <path
              className="circle"
              strokeDasharray={`${number}, 100`}
              d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="#c51369"
              strokeWidth="2"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            {icon}
          </div>
        </div>
      </div>
      <div className="mt-20 text-center">
        <p className="text-2xl font-bold">{number}</p>
        <p className="capitalize text-md tracking-wide">{label}</p>
      </div>
    </div>
  );
};

export default UserWidgets;
